import React from "react";
import { Button, Icon } from 'react-materialize';

export default function ShowColumnBtn({ handleEvents }) {
    return <Button
        flat
        node="button"
        waves="light"
        className="btn-top-right textcolor-green"
        id="btn-showcolumn"
        onClick={handleEvents.OnClick}
    >
        Show Column
        <Icon right>view_column</Icon>
    </Button>
}